module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-waterfall-easy",
    style: (_vm.isMobile ? '' : {
      width: _vm.boxWidth * _vm.columnCount + 'px',
      left: '50%',
      marginLeft: -1 * _vm.boxWidth * _vm.columnCount / 2 + 'px'
    })
  }, [_vm._l((_vm.imgsArrC), function(v, i) {
    return _c('div', {
      staticClass: "img-box",
      style: ({
        padding: _vm.gap / 2 + 'px',
        width: _vm.isMobile ? '' : _vm.boxWidth + 'px'
      })
    }, [_c('div', {
      staticClass: "img-inner-box"
    }, [_c('div', {
      staticClass: "img-wraper",
      style: ({
        width: _vm.imgWidthC + 'px',
        height: v.height ? v.height + 'px' : ''
      })
    }, [_c('img', {
      attrs: {
        "src": v.src
      }
    })]), _c('div', {
      staticClass: "img-info"
    }, [_vm._t("default", null, {
      "index": i,
      "value": v
    })], 2)])])
  }), (_vm.isPreloadingC) ? _c('div', {
    staticClass: "loading",
    class: {
      'first-loading': _vm.isFirstTIme
    }
  }, [_c('div', {
    staticClass: "double-bounce1"
  }), _c('div', {
    staticClass: "double-bounce2"
  })]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4595f137","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-waterfall-easy/src/components/vue-waterfall-easy.vue
// module id = 190
// module chunks = 1